import React, { useState, useEffect } from "react";
import image from "../../images/h.png"; // Update your actual image path
import scannerImg from "../../images/qr-code.png";
// import wrapImage from "../images/aaaservices/food.avif"; // adjust path as per your folder structure
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
    loginAdmin, signupAdmin,
    forgotPasswordAPI,
    refreshAuthToken
} from "../Servicefile/authService.jsx";

const Authservice = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [isForgot, setIsForgot] = useState(false);

    const [loginObj, setLoginObj] = useState({
        username: "",
        password: "",
    });

    const [hidePassword, setHidePassword] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [showPasswordFields, setShowPasswordFields] = useState(false);
    const [forgotEmail, setForgotEmail] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [whatsapp, setWhatsapp] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLoginObj((prev) => ({ ...prev, [name]: value }));
    };

    const handleSignup = async (e) => {
        e.preventDefault();

        setIsLoading(true);
        setError("");

        if (!termsAccepted) {
            setIsLoading(false);

            setError(
                "⚠ Please accept the Terms & Conditions before signing up."
            );

            return;
        }

        const requestBody = {
            id: 0,
            name: (loginObj.name || "").trim(),
            email: (loginObj.email || "").trim(),
            phoneNumber: (loginObj.phoneNumber || "").trim(),
            termsAccepted: !!termsAccepted,
            parentId: null,
        };

        try {
            const result = await signupAdmin(requestBody);

            if (result.success) {

                alert("Signup successful!");

                setIsSignup(false);
                setIsForgot(false);

                setLoginObj({
                    name: "",
                    email: "",
                    phoneNumber: "",
                });

                setTermsAccepted(false);
                setError("");

            } else {

                console.error("Signup failed:", result.data);

                setError(
                    result.data?.message ||
                    result.data ||
                    `Signup failed: ${result.status}`
                );
            }

        } catch (error) {

            console.error(error);

            setError("Network error. Check console for details.");

        } finally {

            setIsLoading(false);
        }
    };



    const handleRefresh = async () => {

        const result = await refreshAuthToken();

        if (result.success) {

            alert("Session refreshed successfully");

            console.log("New Token:", result.token);

        } else {

            alert("Session expired. Please login again.");
        }
    };


    // 🟢 LOGIN Function with Refresh Check 
    //  const handleLogin = async (e) =>{
    // all the comminity of the code and all the refreshing of the token access delivered in the real time code and highly secured process procedures 
    // }

    const handleLogin = async (e) => {
        e.preventDefault();

        setIsLoading(true);
        setError("");

        try {
            // 🔥 Calling Service API
            const data = await loginAdmin(
                loginObj.username,
                loginObj.password
            );

            const token = data.token;
            const userId =
                data.Objectid ||
                data.objectId ||
                data.id;

            if (!token || !userId) {
                throw new Error(
                    "Missing token or Objectid in response."
                );
            }

            // 🔄 Clear old data
            localStorage.clear();

            // 💾 Save data
            localStorage.setItem("authToken", token);
            localStorage.setItem(
                "userId",
                userId.toString()
            );

            // 👤 Role
            if (data.role) {
                localStorage.setItem("role", data.role);
            }

            // 🏪 Vendor
            if (data.vendorId) {
                localStorage.setItem(
                    "vendorId",
                    data.vendorId.toString()
                );
            }

            // 👨‍💼 Employee Role
            if (data.employeRole) {
                localStorage.setItem(
                    "employeRole",
                    data.employeRole
                );
            }

            // 📦 Plan Type
            if (data.planType) {
                localStorage.setItem(
                    "planType",
                    data.planType
                );
            }

            // 👨‍👩‍👧 Parent ID
            if (
                data.parentId !== undefined &&
                data.parentId !== null
            ) {
                localStorage.setItem(
                    "parentId",
                    data.parentId.toString()
                );
            }

            // 💼 Employee ID
            const empId =
                data.employeeId ||
                data.empId ||
                data.employee_id ||
                data.employeId ||
                data.employeeid;

            localStorage.setItem(
                "employeeId",
                empId ? empId.toString() : "0"
            );

            // 🔐 Modules
            let modulesToStore = [];

            if (
                Array.isArray(data.businessModules) &&
                data.businessModules.length > 0
            ) {
                modulesToStore = data.businessModules;
            } else {
                modulesToStore = [
                    "Company",
                    "Home",
                    "Settings_Controls",
                    "Client_Management",
                    "Order_Management",
                    "Menu_Management",
                    "Account_History",
                    "Report_Analysis",
                    "Care_Management",
                    "Chef_Management",
                    "Delivery_Management",
                    "Waiter_Management",
                    "Promotions_Discounts",
                    "Catering",
                    "Terms_Conditions",
                ];
            }

            localStorage.setItem(
                "businessModules",
                JSON.stringify(modulesToStore)
            );

            console.log("📦 Stored Modules:", modulesToStore);

            alert("🎉 Login Successful!");

            navigate("/homes");

        } catch (err) {
            console.error("❌ Login error:", err);

            setError("Login failed: " + err.message);

            alert("❌ Invalid Username or Password!");
        } finally {
            setIsLoading(false);
        }
    };



    ////forgot password

    const [loading, setLoading] = useState(false);

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleSubmit = async (
        event
    ) => {
        event.preventDefault();

        setLoading(true);

        setMessage("");

        try {
            await forgotPasswordAPI(
                email
            );

            setMessage(
                "Reset link sent successfully! your email address"
            );

            setIsEmailSubmitted(
                true
            );

        } catch (error) {
            setMessage(
                error.message ||
                "Something went wrong. Try again later."
            );

        } finally {
            setLoading(false);
        }
    };


    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    const [showLogin, setShowLogin] = useState(false);
    const [isSignup, setIsSignup] = useState(false); // ← Add this line
    const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);

    const styles = {
        section: {
            padding: "20px",
            fontFamily: "Arial, sans-serif",
            backgroundColor: "#2a0947",
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // padding: "15px 20px",
            borderRadius: "8px",
            marginBottom: "30px",
            flexWrap: "wrap",
        },
        logo: {
            fontSize: "30px",
            fontWeight: "bold",
            fontFamily: "roboto",
            color: "#ffe124",
        },
        signIn: {
            backgroundColor: "white",
            border: "2px solid white",
            color: "white",
            fontWeight: "bold",
            fontSize: "18px",
            padding: "8px 16px",
            borderRadius: "5px",
            cursor: "pointer",
            color: "rgb(42 9 71)4",
        },

        topText: {
            textAlign: "center",
            marginBottom: "40px",
        },

        topH2: {
            fontSize: "50px",
            marginBottom: "10px",
            fontWeight: "bold",
            color: "white",
        },
        topP: {
            fontSize: "50px",
            fontWeight: "bold",
            color: "white",
        },
        contentContainer: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
            marginBottom: "40px",
            flexWrap: "wrap",
            // marginTop: "-98px",
        },
        textSection: {
            flex: 1,
            minWidth: "280px",
            marginTop: "15px",
        },
        textH3: {
            fontSize: "30px",
            marginBottom: "30px",
            color: "white",
            fontWeight: "bold",
            textAlign: "left",
            // marginLeft: "53px",
        },
        textP: {
            fontSize: "20px",
            color: "white",
            textAlign: "left",
            fontWeight: "200",
            fontWeight: "bold",
            fontFamily: "revert",
        },
        imageSection: {
            flex: 1,
            textAlign: "center",
        },
        image: {
            maxWidth: "100%",
            height: "auto",
            borderRadius: "10px",
        },
        counterContainer: {
            display: "flex",
            justifyContent: "space-around",
            flexWrap: "wrap",
            gap: "20px",
            borderTop: "1px solid #ddd",
            paddingTop: "20px",
        },

        buttonContainer: {
            marginTop: "20px",
        },
        downloadBtn: {
            backgroundColor: "#ffe124",
            color: "rgb(42 9 71)4",
            padding: "12px 25px",
            fontSize: "16px",
            border: "none",
            fontSize: "20px",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "0.3s ease",
            fontWeight: "bold",
            zIndex: "10",
        },
        popupOverlay: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
        },
        popupInner: {
            background: "white",
            padding: "30px",
            borderRadius: "10px",
            textAlign: "center",
            position: "relative",
            maxWidth: "400px",
            animation: "slideUp 0.4s ease",
            zIndex: 1001,
            pointerEvents: "auto",
        },
        closeBtn: {
            position: "absolute",
            top: "10px",
            right: "15px",
            fontSize: "20px",
            background: "none",
            border: "none",
            cursor: "pointer",
        },
        scannerImg: {
            width: "200px",
            height: "auto",
            marginBottom: "15px",
        },
        imageSection: {
            marginTop: "40px",
            textAlign: "center",
        },
        image: {
            width: "100%",
            maxWidth: "600px",
            height: "auto",
            borderRadius: "10px",
            marginTop: "-64px",
        },

        // Responsive styles using media queries
        "@media screen and (max-width: 768px)": {
            header: {
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
            },
            topH2: {
                fontSize: "30px",
                color: "white",
            },
            topP: {
                fontSize: "14px",
                color: "white",
            },
            textP: {
                fontSize: "14px",
                color: "white",
            },
            counterH1: {
                fontSize: "24px",
            },
            contentContainer: {
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
            },
            textSection: {
                width: "100%",
            },
            imageSection: {
                width: "100%",
            },
        },
    };

    return (
        <div style={styles.section}>
            {/* Header */}
            <div className="imagenavbar" style={styles.header}>
                <div className="nav-maamaas" style={styles.logo}>
                    MAAMAA’S
                </div>

                <div
                    className="nav-links d-flex align-items-center gap-4"
                    style={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                    <button
                        className="signinnmaamaas"
                        style={{
                            backgroundColor: "rgb(255 225 36)",
                            color: "black",
                            fontSize: "20px",
                            fontFamily: "Lato, sans-serif",
                            fontWeight: "bold",
                            borderRadius: "16px",
                            width: "90px",
                            height: "40px",
                            border: "none",
                            cursor: "pointer",
                        }}
                        onClick={() => setShowLogin(true)}
                    >
                        Signin
                    </button>
                </div>

                <div
                    style={{
                        position: "fixed",
                        top: 20,
                        right: showLogin ? "0" : "-100%",
                        width: "100%",
                        maxWidth: "400px",
                        // height: "76vh",
                        backgroundColor: "white",
                        borderRadius: "20px",
                        padding: "40px 30px",
                        boxShadow: "-5px 0 15px rgba(0, 0, 0, 0.1)",
                        transition: "right 0.5s ease-in-out",
                        zIndex: 999,
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        overflowY: "auto",
                    }}
                >
                    {/* Close Button */}
                    <button
                        style={{
                            position: "absolute",
                            top: "15px",
                            right: "20px",
                            fontSize: "28px",
                            background: "none",
                            border: "none",
                            color: "#333",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            setShowLogin(false);
                            setIsForgot(false);
                            setIsSignup(false);
                        }}
                    >
                        &times;
                    </button>

                    <p
                        style={{
                            marginBottom: 0,
                            fontFamily: "revert",
                            fontSize: "22px",
                            color: "#2a0947",
                            fontWeight: "bold",
                        }}
                    >
                        WELCOME TO MAAMAA'S
                    </p>

                    {/* Login Form */}
                    {!isSignup && !isForgot && (
                        <>
                            <form
                                onSubmit={handleLogin}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                }}
                            >
                                <input
                                    type="text"
                                    name="username"
                                    placeholder="Enter name"
                                    value={loginObj.username}
                                    onChange={handleChange}
                                    style={{
                                        padding: "10px 40px 10px 10px", // space on right for the icon
                                        fontSize: "16px",
                                        border: "1px solid #ccc",
                                        borderRadius: "6px",
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                />

                                <div
                                    style={{
                                        position: "relative",
                                        marginBottom: "20px",
                                        width: "100%",
                                    }}
                                >
                                    <input
                                        type={hidePassword ? "password" : "text"}
                                        name="password"
                                        placeholder="Enter Password"
                                        value={loginObj.password}
                                        onChange={handleChange}
                                        style={{
                                            padding: "10px 40px 10px 10px", // space on right for the icon
                                            fontSize: "16px",
                                            border: "1px solid #ccc",
                                            borderRadius: "6px",
                                            width: "100%",
                                            boxSizing: "border-box",
                                        }}
                                    />
                                    <span
                                        onClick={() => setHidePassword((prev) => !prev)}
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#555",
                                        }}
                                    >
                                        {hidePassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>

                                {/* <div style={{ textAlign: "right" }}>
                                    <span
                                        onClick={() => setIsForgot(true)}
                                        style={{
                                            color: "#007bff",
                                            fontSize: "14px",
                                            textDecoration: "none",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Forget Password?
                                    </span>
                                </div> */}
                                {error && (
                                    <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
                                )}
                                <button
                                    type="submit"
                                    style={{
                                        backgroundColor: "rgb(42 9 71)",
                                        color: "white",
                                        fontWeight: "bold",
                                        padding: "12px",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                    }}
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Logging in..." : "LOGIN"}
                                </button>
                            </form>
                        </>
                    )}

                    {/* Forgot Password Form */}

                    {/* Show form only if NOT submitted */}
                    {isForgot && !isEmailSubmitted && (
                        <div>
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        style={{
                                            padding: "10px",
                                            fontSize: "16px",
                                            border: "1px solid #ccc",
                                            borderRadius: "6px",
                                            marginBottom: "10px",
                                            width: "100%",
                                        }}
                                    />
                                </div>

                                <button
                                    type="submit"
                                    style={{
                                        backgroundColor: "rgb(42 9 71)",
                                        color: "white",
                                        fontWeight: "bold",
                                        padding: "12px",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        width: "100%",
                                    }}
                                    disabled={loading}
                                >
                                    {loading ? "Sending..." : "Submit"}
                                </button>
                            </form>
                        </div>
                    )}

                    {/* Show success message only after submit */}
                    {isForgot && isEmailSubmitted && (
                        <div style={{ textAlign: "center", marginTop: "30px" }}>
                            {/* <h3 style={{ color: "green" }}>✅ Check your email</h3> */}
                            <p>
                                {message ||
                                    "A reset password link has been sent to your email address."}
                            </p>
                        </div>
                    )}



                    {/* Signup Form */}
                    {isSignup && (
                        <>
                            <form
                                onSubmit={handleSignup}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                }}
                            >
                                <input
                                    type="text"
                                    name="name" // ✅ Fix
                                    placeholder="Name"
                                    value={loginObj.name}
                                    onChange={handleChange}
                                    style={inputStyle}
                                />
                                <input
                                    type="email"
                                    name="email" // ✅ Fix
                                    placeholder="Email"
                                    value={loginObj.email}
                                    onChange={handleChange}
                                    style={inputStyle}
                                />
                                <input
                                    type="text"
                                    name="phoneNumber" // ✅ Fix
                                    placeholder="Phone Number"
                                    value={loginObj.phoneNumber}
                                    onChange={handleChange}
                                    style={inputStyle}
                                />

                                <div
                                    style={{
                                        position: "relative",
                                        marginBottom: "20px",
                                        width: "100%",
                                    }}
                                >
                                </div>

                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <input
                                        type="checkbox"
                                        checked={termsAccepted}
                                        onChange={(e) => setTermsAccepted(e.target.checked)}
                                    />
                                    <a
                                        rel="noopener noreferrer"
                                        style={{
                                            fontSize: "14px",
                                            color: "#007bff",
                                            textDecoration: "none",
                                        }}
                                        href="/termsandconditionspage"
                                    >
                                        Terms & Conditions
                                    </a>
                                </div>



                                <button
                                    type="submit"
                                    style={{
                                        backgroundColor: "rgb(42 9 71)",
                                        color: "white",
                                        fontWeight: "bold",
                                        padding: "12px",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                    }}
                                >
                                    {isLoading ? "Signing up..." : "SIGN UP"}
                                </button>

                                {error && (
                                    <div style={{ color: "red", marginTop: "10px" }}>{error}</div>
                                )}
                            </form>
                        </>
                    )}

                    {/* Switch Between Login & Signup */}
                    {!isForgot && (
                        <div style={{ textAlign: "center" }}>
                            {/* <p style={{ fontSize: "14px" }}>
                                {isSignup
                                    ? "Already have an account?"
                                    : "Don't have an account?"}{" "}
                                <span
                                    onClick={() => {
                                        setIsSignup(!isSignup);
                                        setIsForgot(false);
                                    }}
                                    style={{
                                        color: "rgb(42 9 71)",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                    }}
                                >
                                    {isSignup ? "Login here" : "Sign up"}
                                </span>
                            </p> */}
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "20px",
                                    justifyContent: "center",
                                }}
                            >
                                {/* <img
                  src={wrapImage}
                  alt="wrap"
                  style={{ width: "100px", display: "block" }}
                />
                <img
                  src={wrapImage}
                  alt="wrap"
                  style={{ width: "100px", display: "block" }}
                /> */}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div style={styles.topText}>
                <p style={styles.topH2}>Welcome to Maamaas – Go Digital</p>
                <p style={styles.topP}>Earn Fully. Stay in Control.</p>
                <div style={styles.buttonContainer}>
                    <button style={styles.downloadBtn} onClick={togglePopup}>
                        Download App
                    </button>
                </div>

                {showPopup && (
                    <div className="read-popup-inner" style={styles.popupOverlay}>
                        <div className="read-popup-inner" style={styles.popupInner}>
                            <button style={styles.closeBtn} onClick={togglePopup}>
                                ×
                            </button>
                            <img
                                src={scannerImg}
                                alt="QR Code Scanner"
                                style={styles.scannerImg}
                            />
                            <p>Scan the QR code to download the Maamaas App!</p>
                        </div>
                    </div>
                )}
            </div>

            {/* Content */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 col-md-7 col-sm-12">
                        <div style={styles.textSection}>
                            <p style={styles.textH3}>
                                At Maamaas, we believe every business deserves the chance to grow — without heavy commissions, hidden costs, or complicated technology. That’s why we built India’s first zero-commission digital growth platform — designed to put your business in the spotlight while keeping you in full control of your earnings.
                            </p>
                            <p style={{
                                textAlign: "justify",
                                fontSize: "18px",
                                lineHeight: "1.8",
                                fontFamily: "Roboto, sans-serif",
                                fontWeight: "400",
                                margin: "0 auto",
                                width: "90%",
                                color: "white",
                            }}>
                                Step into the digital world effortlessly. With Maamaas, you can create a professional presence that showcases your services, menus, and branding. You’ll be discoverable by customers in your area and beyond, and manage everything from bookings to payments in one simple platform. No middlemen, no restrictions  just pure growth, on your terms.<br /> <br />Whether you’re serving delicious meals, offering essential services, or powering logistics, Maamaas is designed to make your business smarter, stronger, and more profitable.

                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-7 col-sm-12">
                        <div style={styles.imageSection}>
                            <img src={image} alt="Learning" style={styles.image} />
                        </div>
                    </div>
                </div>
            </div>


            {/* <div>  fuction<h1> actually collected formated of the prducts and the imageSection of the Learning of the prducts </h1> </div> */}


            {/* Counter Section */}
        </div>
    );

};

const inputStyle = {
    padding: "10px",
    fontSize: "16px",
    border: "1px solid #ccc",
    borderRadius: "6px",
};


export default Authservice;
